import React from 'react';
import qs from 'qs';
import {
  translate,
  Datagrid,
  Edit,
  List,
  SimpleForm,
  TextField,
  TextInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  Filter,
  Create,
  EditButton,
  CreateButton,
  ExportButton,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import Toolbar from '@material-ui/core/Toolbar';

import resourceLocales from './locales';
import resourceConfig from './config';
import LinkToList from './LinkToList';
import exporter from '../../../../utils/exporter';
import inventoryH from '../inventoryH';
import mrkStatusSystem from '../mrkStatusSystem';
import EnumInput from '../../../../components/EnumInput';
import EnumField from '../../../../components/EnumField';
import markingStatus from '../markingStatus';
import ExportDocButton from '../docH/ExportDocButton';
const ResourceIcon = BookmarkIcon;

const listStyles = {};

const trPrefix = `resources.${resourceConfig.name}`;

const ResourceActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total,
  translate,
}) => (
  <Toolbar>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <CreateButton
      basePath={basePath}
      to={`${basePath}/create?${
        filterValues && filterValues.overEntityIds
          ? `_inventoryHId=${filterValues.overEntityIds}`
          : ''
      }`}
    />
    <ExportDocButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
    />
  </Toolbar>
);

const ResourceListFilter = (props) => (
  <Filter {...props}>
    <inventoryH.Input source="overEntityIds" />
    <EnumInput
      source={'result'}
      translatePrefix={`${trPrefix}.enums.result.`}
      label={`${trPrefix}.fields.result`}
      enums={resourceConfig.enums.result}
    />
    <markingStatus.Input source={'status'} />
    <mrkStatusSystem.Input source={'mrkSystemStatus'} />
    <TextInput source={'numGoods'} />
    <TextInput source={'ownerInn'} />
    <TextInput source={'uitCode'} />
  </Filter>
);

const ResourceList = withStyles(listStyles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={<ResourceListFilter />}
    sort={{ field: 'id', order: 'DESC' }}
    actions={<ResourceActions />}
    exporter={exporter}>
    <Datagrid>
      <TextField source={'id'} />
      <inventoryH.Field source={'inventoryHId'} />
      <TextField source={'gtin'} />
      <EnumField
        source={'result'}
        translatePrefix={`${trPrefix}.enums.result.`}
        label={`${trPrefix}.fields.result`}
        enums={resourceConfig.enums.result}
      />
      <TextField source={'status'} />

      <mrkStatusSystem.Field source={'mrk_system_status'} />
      <TextField source={'num_goods'} />
      <TextField source={'uit_code'} />
      <TextField source={'warehouse'} />
      <TextField source={'ownerInn'} />
      <TextField source={'statusFm'} />
      <EditButton />
    </Datagrid>
  </List>
));

const ResourceTitle = translate(({ record, translate }) => (
  <span>
    {translate(`resources.${resourceConfig.name}.name`, { smart_count: 1 })} &quot;{record.id}&quot;
  </span>
));

const ResourceCreate = (props) => {
  const defaultData = {};
  if (props.location && props.location.search && props.location.search.length > 1) {
    const params = qs.parse(props.location.search.replace(/^\?/, ''));
    if (params && params._inventoryHId) {
      defaultData.inventoryHId = parseInt(params._inventoryHId);
    }
  }
  return (
    <Create {...props}>
      <SimpleForm>
        <inventoryH.Input source={'inventoryHId'} defaultValue={defaultData.inventoryHId} />
        <TextInput source={'gtin'} />
        <mrkStatusSystem.Input source={'mrk_system_status'} />
        <TextInput source={'num_goods'} />
        <EnumInput
          source={'result'}
          translatePrefix={`${trPrefix}.enums.result.`}
          label={`${trPrefix}.fields.result`}
          enums={resourceConfig.enums.result}
        />
        <TextInput source={'status'} />
        <TextInput source={'uit_code'} />
        <TextInput source={'warehouse'} />
        <TextField source={'ownerInn'} />
        <TextField source={'statusFm'} />
      </SimpleForm>
    </Create>
  );
};

const ResourceEdit = (props) => (
  <Edit redirect={null} undoable={false} title={<ResourceTitle />} {...props}>
    <SimpleForm redirect={false}>
      <TextField source={'id'} />
      <inventoryH.Input source={'inventoryHId'} />
      <TextInput source={'gtin'} />
      <mrkStatusSystem.Input source={'mrk_system_status'} />
      <TextInput source={'num_goods'} />
      <EnumInput
        source={'result'}
        translatePrefix={`${trPrefix}.enums.result.`}
        label={`${trPrefix}.fields.result`}
        enums={resourceConfig.enums.result}
      />
      <TextInput source={'status'} />
      <TextInput source={'uit_code'} />
      <TextInput source={'warehouse'} />
      <TextField source={'ownerInn'} />
      <TextField source={'statusFm'} />
    </SimpleForm>
  </Edit>
);

const ResourceReferenceField = (props) => (
  <ReferenceField reference={resourceConfig.name} linkType={'show'} {...props}>
    <TextField source={'id'} />
  </ReferenceField>
);

const ResourceReferenceArrayField = (props) => (
  <ReferenceArrayField reference={resourceConfig.name} linkType={'show'} {...props}>
    <SingleFieldList>
      <ChipField source={'id'} />
    </SingleFieldList>
  </ReferenceArrayField>
);

const ResourceReferenceInput = (props) => (
  <ReferenceInput reference={resourceConfig.name} {...props}>
    <SelectInput optionText={'id'} />
  </ReferenceInput>
);

const ResourceReferenceArrayInput = (props) => (
  <ReferenceArrayInput reference={resourceConfig.name} {...props}>
    <SelectArrayInput optionText={'id'} />
  </ReferenceArrayInput>
);

export default {
  Icon: ResourceIcon,
  List: ResourceList,
  Title: ResourceTitle,
  Edit: ResourceEdit,
  Create: ResourceCreate,
  Field: ResourceReferenceField,
  ArrayField: ResourceReferenceArrayField,
  Input: ResourceReferenceInput,
  ArrayInput: ResourceReferenceArrayInput,
  LinkToList,

  name: resourceConfig.name,
  resourceConfig: {
    name: resourceConfig.name,
    list: ResourceList,
    // show: ResourceShow,
    icon: ResourceIcon,
    edit: ResourceEdit,
    create: ResourceCreate,
  },
  locales: resourceLocales,
  restProviderResolve: {
    name: resourceConfig.name,
    apiService: resourceConfig.apiService,
    basePath: resourceConfig.apiPath,
    schema: {},
  },
};
